export default {
  "___print-screen_title_confirm-close": "",
  "___print-screen_text_confirm-close": "",
  "___print-screen_action_confirm-close_cancel": "",
  "___print-screen_action_confirm-close_confirm": "",
  "___print-screen_action_print": ""
};